'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _reactBootstrapModal = require('react-bootstrap-modal');

var _reactBootstrapModal2 = _interopRequireDefault(_reactBootstrapModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common');
var ModalDialog = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ModalDialog, _React$PureComponent);

    function ModalDialog() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ModalDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModalDialog.__proto__ || (0, _getPrototypeOf2.default)(ModalDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function (submitted) {
            var _this$props = _this.props,
                onClose = _this$props.onClose,
                onSubmit = _this$props.onSubmit;

            if (submitted && onSubmit) {
                onSubmit();
            } else {
                onClose(submitted);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ModalDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                show = _props.show,
                title = _props.title,
                submitButtonText = _props.submitButtonText,
                cancelButtonText = _props.cancelButtonText,
                showCancelButton = _props.showCancelButton,
                hideSubmitButton = _props.hideSubmitButton;

            if (!show) return null;
            return _react2.default.createElement(
                _reactBootstrapModal2.default,
                {
                    dialogClassName: this.props.dialogClassName,
                    show: this.props.show,
                    onHide: function onHide() {
                        return _this2.onClose(false);
                    },
                    style: this.props.style,
                    'aria-labelledby': 'ModalHeader' },
                _react2.default.createElement(
                    _reactBootstrapModal2.default.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        'button',
                        { className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close',
                            onClick: function onClick() {
                                return _this2.onClose(false);
                            } },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '\xD7'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        { className: 'modal-title' },
                        title
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrapModal2.default.Body,
                    null,
                    this.props.children
                ),
                _react2.default.createElement(
                    _reactBootstrapModal2.default.Footer,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'text-right' },
                        !hideSubmitButton && _react2.default.createElement(
                            'button',
                            { className: 'btn btn--sm btn--green', onClick: function onClick() {
                                    return _this2.onClose(true);
                                } },
                            _react2.default.createElement('i', { className: 'icon--save' }),
                            ' ',
                            submitButtonText || Resx.Common.Save
                        ),
                        !!showCancelButton && _react2.default.createElement(
                            'button',
                            { className: 'btn btn--sm', onClick: function onClick() {
                                    return _this2.onClose(false);
                                } },
                            cancelButtonText || Resx.Common.Cancel
                        )
                    )
                )
            );
        }
    }]);
    return ModalDialog;
}(_react2.default.PureComponent), _class.propTypes = {
    title: _propTypes2.default.string,
    submitButtonText: _propTypes2.default.string,
    cancelButtonText: _propTypes2.default.string,
    dialogClassName: _propTypes2.default.string,
    showCancelButton: _propTypes2.default.bool,
    onSubmit: _propTypes2.default.func,
    hideSubmitButton: _propTypes2.default.bool,
    style: _propTypes2.default.object,

    show: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ModalDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/ModalDialog.js
// module id = 747
// module chunks = 0